import { TefProductCodeData } from "../../types/tefConfiguration/tefProductCodes.type"
import TefConfigurationProductUpdateModal from "../../pages/Tabs/TefConfiguration/Update"
import { dateTimeTransformer } from "@/common/utils/dateTransformer"

export class TefProductCodesTransformer {
  static tableTransformer() {
    return (productCodes: TefProductCodeData[]) => {
      return productCodes.map((tefProductCode) => ({
        product_category: tefProductCode.product.category.display_name,
        product: tefProductCode.product.display_name,
        code: tefProductCode.code,
        updated_at: tefProductCode.updated_at ? dateTimeTransformer(new Date(tefProductCode.updated_at)) : '',
        actions: (
          <>
            <TefConfigurationProductUpdateModal tefProductCode={tefProductCode} />
          </>
        ),
      }))
    }
  }
}
